import React from "react";
import DropDown from "./DropDown";
import { useAppContext } from "../../helpers/account-context";
import { cleanAvailableTags } from "../../helpers/helper";


const TagDropdown = (props) => {
  const { filters, onChangeFilters } = props;

  // https://codepen.io/smithsuth/pen/VvYzZP
  const title = filters.tags && filters.tags.length > 0 ? ` (${filters.tags.length})` : '';
  const { initedData: {enabledTags, hiddenFilters}, account: { tags }, getLocale } = useAppContext()
  const isHidden = !!hiddenFilters && (hiddenFilters.indexOf('tags') >= 0 || hiddenFilters.indexOf('all') >= 0);
  if(isHidden) return null;
  const tagOptions = cleanAvailableTags(tags, enabledTags);

  if(!tagOptions || tagOptions.length === 0) return null;

  return  (
    <DropDown
      className="cbmap-dropdown-tags"
      title={
       `${getLocale("tags")}${title}`
      }
      items={tagOptions}
      selectedItems={filters.tags || []}
      isMulti={true}
      onChange={(newTags) => onChangeFilters({ ...filters, tags: newTags })}
    />
  )
};

export default TagDropdown;
